<div class="measurement-input" [ngClass]="{ 'margin-bottom' : hasError }">
    <!-- Drop Down Custom Input Field -->
    <mat-form-field
        [appearance]="appearance"
        [floatLabel]="floatLabel"
        [ngClass]="{ hasError: hasError, 'less-margin': margin }"
    >
        <mat-label [ngClass]="{ inputIsWrong: hasError }">{{ placeholder }}</mat-label>
        <input
            #customInput
            matInput 
            autocomplete="off"
            (focus)="showCustomMeasurement()"
            (keyup)="checkInputText($event)"
            (blur)="checkInputText($event)"
            (blur)="hideCustomMeasurement()"
            [type]="'tel'"
            [maxLength]="6"
            [placeholder]="'Enter'"
            [ngClass]="{ inputIsWrong: hasError }"
            [(ngModel)]="defaultValue"
            oncopy="return false"
		    onpaste="return false"
        />
    </mat-form-field>
    <div *ngIf="showMeasurement" class="custom-measurement" [ngClass]="{'custom-less-height' : margin}">
        {{ measurement }}
    </div>
    <div class="validation-image">
        <img *ngIf="!hasError && showValidTick" [src]="validImage" alt="valid-image" class="valid-img">
        <img *ngIf="hasError" [src]="invalidImage" alt="invalid-image" class="invalid-img">
    </div>
    <!-- Drop Down Error Message -->
    <span class="error-message" *ngIf="hasError">{{ errorMessage }}</span>
</div>